import React from 'react';
import { motion } from 'framer-motion';
import { useData } from '../../context/DataContext';
import { useAuth } from '../../context/AuthContext';
import StatsCards from './StatsCards';
import TasksOverview from './TasksOverview';
import TeamPerformance from './TeamPerformance';
import RecentActivity from './RecentActivity';
import ClientsPipeline from './ClientsPipeline';

const Dashboard = () => {
  const { tasks, clients, teamMembers } = useData();
  const { user, hasPermission } = useAuth();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-6"
    >
      <motion.div variants={itemVariants}>
        <h1 className="text-3xl font-bold text-gray-900">
          Welcome back, {user?.name}!
        </h1>
        <p className="text-gray-600 mt-1">
          Here's what's happening with your team today.
        </p>
      </motion.div>

      <motion.div variants={itemVariants}>
        <StatsCards tasks={tasks} clients={clients} teamMembers={teamMembers} />
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <motion.div variants={itemVariants}>
          <TasksOverview tasks={tasks} />
        </motion.div>

        <motion.div variants={itemVariants}>
          <ClientsPipeline clients={clients} />
        </motion.div>
      </div>

      {(hasPermission('view_team') || hasPermission('all')) && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <motion.div variants={itemVariants}>
            <TeamPerformance teamMembers={teamMembers} />
          </motion.div>

          <motion.div variants={itemVariants}>
            <RecentActivity tasks={tasks} />
          </motion.div>
        </div>
      )}
    </motion.div>
  );
};

export default Dashboard;